import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import { PinType } from '@store/weathermap.store';
import { LayersService } from 'src/app/services/layers.service';
import { UnitComponent } from 'src/app/toolbar/settings/unit/unit.component';
import { ToolbarSectionComponent } from 'src/app/toolbar/toolbar-panel/toolbar-section/toolbar-section.component';
import { ToolbarSelectItemComponent } from 'src/app/toolbar/toolbar-panel/toolbar-select-item/toolbar-select-item.component';
import { UNIT_PRESSURE_CACHE_KEY, UNIT_SYSTEM_CACHE_KEY, UNIT_WIND_CACHE_KEY } from 'src/app/weathermap.const';

@Component({
  selector: 'app-settings',
  imports: [
    TextModule,
    UnitComponent,
    PipesModule,
    ToolbarSectionComponent,
    ToolbarSelectItemComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent {
  unitSystem = this.weathermapFacade.unitSystem;
  windUnit = this.weathermapFacade.windUnit;
  pressureUnit = this.weathermapFacade.pressureUnit;

  constructor(
    private readonly weathermapFacade: WeathermapFacade,
    private readonly layersService: LayersService,
  ) {}

  selectUnitSystem(unitSystem: number): void {
    this.weathermapFacade.selectUnitSystem(unitSystem);
    localStorage.setItem(UNIT_SYSTEM_CACHE_KEY, `${unitSystem}`);
    if (this.weathermapFacade.selectedPintype() === PinType.TEMPERATURE) {
      this.layersService.reloadLayers();
    }
  }

  selectUnitWind(windUnit: number): void {
    this.weathermapFacade.selectUnitWind(windUnit);
    localStorage.setItem(UNIT_WIND_CACHE_KEY, `${windUnit}`);
  }

  selectUnitPressure(pressureUnit: number): void {
    this.weathermapFacade.selectUnitPressure(pressureUnit);
    localStorage.setItem(UNIT_PRESSURE_CACHE_KEY, `${pressureUnit}`);
  }
}
